export default __webpack_public_path__ + "static/media/empty_outlet.e4e67490.png";